module.exports = __webpack_public_path__ + "assets/fcc916e68bae286f4db9e795d7e60bbe.png";